/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import PageHero from '../containers/Pages/PageHero';
import RosterGrid from '../containers/Artists/shared/RosterGrid';
import HomeFooter from '../containers/Home/HomeFooter';

const Artists = () => (
  <div>
    <PageHero
      meta={['Vol. 01 — The Roster', 'Independent Record Label']}
      eyebrow="Our Artists"
      title="Una casa"
      italic="de voces."
      lede="Seis firmas independientes trabajando bajo un mismo techo. Cada artista es un lenguaje distinto — una ciudad, una historia, una disciplina."
    />
    <RosterGrid />
    <HomeFooter />
  </div>
);

export default Artists;
